"use client";

import React from "react";
import gearImgBackground2 from "../../assets/images/expedition-gear/duffel-bag/gearImg10.png";
import { ArrowUpRight } from "lucide-react";

export default function Cta() {


  return (
      <section className="relative h-[600px] w-full overflow-hidden">
        <img
          src={gearImgBackground2}
          className="absolute inset-0 w-full h-full object-cover"
          alt=""
        />
        <div className="absolute inset-0 bg-[#1a272f]/90" />

        <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
          <h2 className="text-4xl font-bold">
            Ready for the Mountains?
          </h2>

          <p className="mt-6 text-white/70 max-w-xl">
            Plan your expedition with confidence. Our team assists every climber
            with personalized gear planning before departure.
          </p>

          <a
            href="/contact"
            className="mt-10 inline-flex items-center gap-2
              rounded-full bg-white/20 px-8 py-4 text-sm
              backdrop-blur hover:bg-white/30 transition"
          >
            Talk to an Expedition Expert
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </section>
  );
}
